import { render } from "./7.Partners.vue?vue&type=template&id=2700432a&scoped=true"
import script from "./7.Partners.vue?vue&type=script&lang=js"
export * from "./7.Partners.vue?vue&type=script&lang=js"

import "./7.Partners.vue?vue&type=style&index=0&id=2700432a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2700432a"]])

export default __exports__